const loginPagesHashes = [
  '/login',
  '/logout',
  '/logout/clear',
  '/organization',
  '/confirm-password',
  '/set-password',
  '/set-new-password',
  '/company-signup',
  '/reset-password',
  '/login-redirect',
  '/company-page',
  '/privacy-policy',
  '/request-demo',
  '/support',
  '/maintenance',
  '/browser-invalid'
];

export default loginPagesHashes;
